<ul>
  <li *ngFor="let address of addresses">{{ address }}</li>
</ul>
